import styled from "styled-components";

export const AreaButtons = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 16px;
	grid-column: 1 / -1; /* Força a ocupar todas as colunas do Grid */
	margin-top: 8px;
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 1rem;

	> ${AreaButtons} {
		grid-column: 3 / 3;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-template-columns: repeat(2, 1fr);

		> ${AreaButtons} {
			grid-column: 2/2;
		}
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		display: flex;
		flex-direction: column;

		> ${AreaButtons} {
			flex-direction: column;

			> button {
				width: 100%;
				max-width: 100%;
			}
		}
	}
`;
